import {useState,useCallback} from 'react';
import { LegacyStack, Button, Text } from "@shopify/polaris";
import { ResourcePicker } from '@shopify/app-bridge-react';

const getSelectionIds = (input) => [input.id]
    .filter(Boolean)
    .map(id => ({ id }));

export function CollectionPicker ({ field, label, form, handleChange, errors }) {
    const [showPicker, setShowPicker] = useState(false);

    const activate = useCallback(() => setShowPicker(true), []);
    const onOriginSelection = useCallback((value) => {
        const [
            selection = {
                id: '',
                title: '',
            }
        ] = value.selection;

        handleChange({
            id: selection.id,
            title: selection.title,
        }, `configuration.${field}`)

        setShowPicker(false);
    }, [form.configuration[field]])

    const onCancel = useCallback(() => {
        setShowPicker(false);
    }, [field]);

    const activator = !form.configuration[field].id
        ? (<Button onClick={activate}>Choose {label}</Button>)
        : (
            <div>
                <Text  variant="bodyMd" as="span" fontWeight="semibold">{label}</Text>: {form.configuration[field].title} (<Button onClick={activate}  size='slim' variant="plain">change</Button>)
            </div>
        );

    return <>
        <LegacyStack vertical>
            {activator}
        </LegacyStack>
        <ResourcePicker open={showPicker}
                        resourceType="Collection"
                        initialSelectionIds={getSelectionIds(form.configuration[field])}
                        selectMultiple={false}
                        onSelection={onOriginSelection}
                        onCancel={onCancel} />
    </>;
}
